import { SearchLink } from "./types.ts";
import { useNavigate, useNavigation } from "react-router-dom";
import { useEffect, useMemo } from "react";
import useUserPreference from "../../actions/user/useUserPreference.ts";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import { getSearchQuery } from "../query.ts";
import { getBasePathWithTrailingSlash } from "../../../../common/env.ts";

const MAX_HISTORY = 5;

export default function useRecentSearches(): SearchLink[] {
  const navigate = useNavigate();
  const { location } = useNavigation();
  const [recentSearches, setRecentSearches] = useUserPreference<string[]>(
    UserPreferenceKey.HomeSearchHistory
  );
  const recent = useMemo(() => recentSearches ?? [], [recentSearches]);

  useEffect(() => {
    if (
      location?.pathname === getBasePathWithTrailingSlash() + "search/titles" ||
      location?.pathname ===
        getBasePathWithTrailingSlash() + "search/book-content"
    ) {
      const params = new URLSearchParams(location.search);
      const term = getSearchQuery(params);
      if (term) {
        const index = recent.findIndex((recent) => recent === term);
        if (index === -1) {
          setRecentSearches([term].concat(recent.slice(0, MAX_HISTORY - 1)));
        } else if (index !== 0) {
          const cur = recent.splice(index, 1);
          setRecentSearches(cur.concat(recent));
        }
      }
    }
  }, [location?.pathname, location?.search, recent, setRecentSearches]);
  return recent.map((term) => ({
    term,
    type: "titles",
    action: () => navigate(`/search/titles?q=${encodeURIComponent(term)}`),
  }));
}
